'use client';

import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper } from 'swiper/react';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const ProductSlider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '25vh',
        '& .swiper': {
          minHeight: '25vh',
          paddingBottom: '2rem',
          '& .swiper-slide': {
            minHeight: '25vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          '& .swiper-pagination': {
            bottom: '1rem',
          },
          '& .swiper-pagination-bullet-active': {
            backgroundColor: 'secondary.dark',
          },
          '& .swiper-button-next': {
            top: '0',
            height: '100%',

            '&:after': {
              color: 'secondary.dark',
              opacity: '0.125',
              marginLeft: '-1rem',
              transition: 'margin-left 0.5s ease-in-out, opacity 0.5s ease-in-out',
            },

            '&: hover': {
              '&:after': {
                opacity: '1',
                marginLeft: '0rem',
              },
            },
          },
          '& .swiper-button-prev': {
            top: '0',
            height: '100%',

            '&:after': {
              color: 'secondary.dark',
              opacity: '0.125',
              marginRight: '-1rem',
              transition: 'margin-right 0.5s ease-in-out, opacity 0.5s ease-in-out',
            },

            '&: hover': {
              '&:after': {
                opacity: '1',
                marginRight: '0rem',
              },
            },
          },
        },
      }}
    >
      <Swiper
        // install Swiper modules
        modules={[Navigation, Pagination]}
        spaceBetween={50}
        slidesPerView={4}
        navigation={true}
        pagination={{ clickable: true }}
        onSwiper={noop}
        onSlideChange={noop}
      >
        {children}
      </Swiper>
    </Box>
  );
};
